import { createGlobalStyle } from 'styled-components';

import interLight from '../assets/fonts/Inter-Light.ttf';
import interRegular from '../assets/fonts/Inter-Regular.ttf';
import interBold from '../assets/fonts/Inter-Bold.ttf';
import interVariable from '../assets/fonts/Inter-Variable.ttf';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px;
  }

  @font-face {
  font-family: 'Inter Light';
  src: url(${interLight});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Inter Regular';
  src: url(${interRegular});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Inter Bold';
  src: url(${interBold});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Inter';
  src: url(${interVariable}) format('truetype');
  font-weight: 100 900;
  font-style: normal;
}


  body {
    margin: 0;
    font-family: 'Inter Regular', -apple-system, BlinkMacSystemFont,
      'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
      'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${({ theme }) => theme.text};
    height: 100vh;
  }
  // global component styles
  a {
    color: ${({ theme }) => theme.foreground};
    text-decoration: none;
  }
`;

export default GlobalStyle;
